import { useDesignMaxTheme } from "@/packages";
import { Center, Flex } from "@chakra-ui/react";
import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { SpecialDetail, SpecialSlide } from "./components";
import { type SpecialPreviewProps } from "./specialPreview.type";

export const SpecialPreview = ({ data }: SpecialPreviewProps) => {
    const { ref } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });
    const [currentIdx, setCurrentIdx] = useState(0);
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    const { specials } = { ...data };
    const nextSlide = () => {
        setCurrentIdx((prev) => (prev === (specials.length as number) - 1 ? 0 : prev + 1));
    };
    const prevSlide = () => {
        setCurrentIdx((prev) => (prev === 0 ? (specials.length as number) - 1 : prev - 1));
    };
    return (
        <Center ref={ref} position="relative" width="100%" background=" #FBF6F2">
            <Flex as="section" p={isMobile ? "56px 0" : "120px 0"} justifyContent="flex-end">
                <Flex maxW="1760px !important" w="100%" flexDir={isMobile ? "column-reverse" : "row"}>
                    <SpecialDetail
                        specials={specials}
                        currentIdx={currentIdx}
                        nextSlide={nextSlide}
                        prevSlide={prevSlide}
                    />
                    <SpecialSlide specials={specials} currentIdx={currentIdx} />
                </Flex>
            </Flex>
        </Center>
    );
};
